import * as Yup from 'yup';

const validationSchema = Yup.object({
  name: Yup.string()
    .required('Name is required'),
  email: Yup.string()
    .email('Email is invalid')
    .required('Email is required'),
  primarySocial: Yup.string()
    .required('Primary social platform is required'),
  primaryHandle: Yup.string()
    .required('Primary social handle is required'),
  coachDriveFolder: Yup.string()
    .required('Coach Drive Folder URL is required')
    .test('is-google-drive-folder', 'Please enter a valid Google Drive folder URL', (value) => {
      if (!value) return false;

      // Check if it's a valid Google Drive folder URL
      const googleDriveFolderRegex = /^https:\/\/drive\.google\.com\/drive\/folders\/[a-zA-Z0-9_-]+(\?.*)?$/;
      return googleDriveFolderRegex.test(value);
    }),
});

export {
  validationSchema,
};
